import { __awaiter, __generator } from "tslib";
import { CreationError, } from '@office-start/create-types';
export function getFreshAccessToken(componentContext, userEntitlements) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!componentContext || !userEntitlements) {
                        throw new CreationError('Invalid create item options', "Error" /* CreateDocumentResultType.Error */);
                    }
                    return [4 /*yield*/, componentContext.getAccessToken('OneDrive', false, userEntitlements.OneDriveResourceId)];
                case 1:
                    accessToken = _a.sent();
                    if (!accessToken || !accessToken.success) {
                        throw new CreationError('Invalid accessToken', "Error" /* CreateDocumentResultType.Error */);
                    }
                    return [2 /*return*/, accessToken];
            }
        });
    });
}
//# sourceMappingURL=getFreshAccessToken.js.map